//import React from 'react';
const PAGE = {
  	"ENGLISH": {
		"HEADER": {
			"BASEURL": "https://smiles.club",
			"TITLE": "Smiles Club | Use a promo code here to get your Clear Aligners EVEN CHEAPER!",
			"DESCRIPTION": "Got a promotional code from your favorite influencer? Use it here to get the full Straightening Treatments at a significant discounted price!",
			"KEYWORDS": "Promotional Code, Influencer Clear Aligners, Teeth Straightening Treatments, Smiles.Club, Smiles Club, clear treatment code, non-toxic aligners, risk free experience, flexible payment options, compare aligners, price compare"
		},
		"CONTENT": {
			"LoginHeader": [
				{
					"type": "div",
					"content": `
						<div class="preHeader">Login</div>
						<h1 class="sectionTitle">Welcome to our Portal</h1>
						<div class="">This is the place where you will see the treatment progression videos, the treatment tracking with before and after pictures, your payment history, etc.</div>
					`
				}
			],
			"Login": [
				{
					"type": "div",
					"content": `<p class="">Email or Password failed</p>` //FAILED MESSAGE
				},
				{
					"type": "span",
					"content": `Login`
				}
			]
		}
	},
	"ESPAÑOL": {
		"HEADER": {
			"BASEURL": "https://sonrisas.club",
			"TITLE": "Sonrisas Club | Use un código de promoción aquí para obtener sus alineadores transparentes AÚN MÁS BARATOS",
			"DESCRIPTION": "¿Tienes un código promocional de uno de tus influencers favoritos? ¡Úselo en este sitio web para obtener los tratamientos de alisado completos a un precio con un descuento significativo!",
			"KEYWORDS": "Alisado de dientes en casa, asequible, frenos transparentes, frenos invisibles, los mejores alineadores, los alineadores más seguros, los alineadores transparentes número uno, los alineadores invisibles, BPA, opciones financieras, plásticos seguros, discretamente, alternativa de frenos"
		},
		"CONTENT": {
			"LoginHeader": [
				{
					"type": "div",
					"content": `
						<div class="preHeader">INICIAR SESIÓN</div>
						<h1 class="sectionTitle">Bienvenidos a nuestro portal</h1>
						<div class="">Este es el lugar donde verás los videos del progreso del tratamiento, el seguimiento del tratamiento con fotos de antes y después, tu historial de pagos, etc.</div>
					`
				}
			],
			"Login": [
				{
					"type": "div",
					"content": `<p class="">Email o Contraseña estan incorrecto</p>` //FAILED MESSAGE
				},
				{
					"type": "span",
					"content": `Entrar`
				}
			]
		}
	}
};


	
export default PAGE;


